import { Category } from '../types'

export const categories: Category[] = [
  {
    id: 'pools',
    name: 'Басейни',
    slug: 'basejny',
    image: 'https://images.unsplash.com/photo-1575429198097-0414ec08e8cd?w=600',
    description: 'Каркасні, надувні та стаціонарні басейни для дому та дачі',
    productCount: 45,
  },
  {
    id: 'jacuzzi',
    name: 'Джакузі та крижанні вани',
    slug: 'dzhakuzi-ta-kryzhanni-vany',
    image: 'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=600',
    description:
      'СПА-басейни, гідромасажні ванни та крижанні вани для загартування',
    productCount: 18,
  },
  {
    id: 'chemicals',
    name: 'Хімія для басейну',
    slug: 'khimiya-dlya-basejnu',
    image: 'https://images.unsplash.com/photo-1563453392212-326f5e854473?w=600',
    description: 'Засоби для очищення, дезінфекції та підтримки якості води',
    productCount: 67,
  },
  {
    id: 'equipment',
    name: 'Обладнання для басейну',
    slug: 'obladnannya-dlya-basejnu',
    image: 'https://images.unsplash.com/photo-1572331165267-854da2b021aa?w=600',
    description: 'Насоси, фільтри, нагрівачі та системи очищення води',
    productCount: 89,
  },
  {
    id: 'finishing',
    name: 'Оздоблювальні матеріали',
    slug: 'ozdoblyuvalni-materialy',
    image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=600',
    description: 'Плитка, мозаїка, плівка ПВХ та інші матеріали для оздоблення',
    productCount: 34,
  },
  {
    id: 'pipes',
    name: 'Труби та фітинги',
    slug: 'truby-ta-fitynhy',
    image: 'https://images.unsplash.com/photo-1585704032915-c3400ca199e7?w=600',
    description:
      "Труби, з'єднувачі та арматура для систем водопостачання басейну",
    productCount: 56,
  },
  {
    id: 'covers',
    name: 'Накриття для басейну',
    slug: 'nakryttya-dlya-basejnu',
    image: 'https://images.unsplash.com/photo-1562778612-e1e0cda9915c?w=600',
    description: 'Захисні накриття, тенти та ролети для басейнів',
    productCount: 23,
  },
  {
    id: 'accessories',
    name: 'Аксесуари для басейну',
    slug: 'aksesuary-dlya-basejnu',
    image: 'https://images.unsplash.com/photo-1530549387789-4c1017266635?w=600',
    description: 'Сходи, поручні, термометри, освітлення та інші аксесуари',
    productCount: 78,
  },
  {
    id: 'embedded',
    name: 'Закладні для басейну',
    slug: 'zakladni-dlya-basejnu',
    image: 'https://images.unsplash.com/photo-1519046904884-53103b34b206?w=600',
    description: 'Скімери, форсунки, донні зливи та інші закладні елементи',
    productCount: 41,
  },
  {
    id: 'aquafitness',
    name: 'Аквафітнес і відпочинок на воді',
    slug: 'akvafitnes-i-vidpochynok-na-vodi',
    image: 'https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=600',
    description: 'Надувні матраци, круги, нудли та обладнання для аквафітнесу',
    productCount: 52,
  },
  {
    id: 'sauna',
    name: 'Обладнання для саун',
    slug: 'obladnannya-dlya-saun',
    image: 'https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=600',
    description: 'Печі, каміння, аксесуари та обладнання для саун і лазень',
    productCount: 38,
  },
  {
    id: 'spare-parts',
    name: 'Запчастини',
    slug: 'zapchastyny',
    image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=600',
    description: 'Запасні частини та комплектуючі для обладнання басейнів',
    productCount: 94,
  },
]

export const getCategoryBySlug = (slug: string): Category | undefined => {
  return categories.find((cat) => cat.slug === slug)
}
